import _ from 'lodash';
import LiveboardsUrlConverter from './liveboards_url_converter';

export default _.extend({}, LiveboardsUrlConverter, {
  getPath() {
    return '/liveboards/floorboard';
  },
});



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/url_converters/floorboard_url_converter.js